import{jsx as r}from"react/jsx-runtime";import{useState as o}from"react";import{styled as d}from"styled-components";import{getBorderColorWithDefault as s,changeColor as i}from"./changeColor.mjs";import{LIGHT_GRAY as e,DARKER_GRAY as t}from"../../../styles/Colors.mjs";const l=d.div`
  max-width: ${({$maxWidth:r})=>r||""};
  float: left;
  padding: 0px 4px;
  border: 1px solid ${r=>s(r,e)};
  border-top: 1px solid ${r=>s(r,t)};
  border-left: 1px solid ${r=>s(r,t)};
  border-radius: 3px;
  ${i}
`;function n({maxWidth:d="550px",shouldHandleFocusEvent:s=!0,children:i,isBlank:e,isError:t,isFocused:n,transparentBorder:a,disabled:m,style:p,id:c}){const[x,$]=o(!1);return r(l,{id:c,className:"field-body",$maxWidth:d,$isFocused:null!=n?n:x,$disabled:m,$isBlank:e,$isError:t,$transparentBorder:a,style:p,onFocus:s?()=>$(!0):void 0,onBlur:s?()=>$(!1):void 0,children:i})}export{n as FieldBody};
